import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const fetchRoles = () => api.get("/careers/roles").then((r) => r.data.roles);
export const submitApplication = (formData) =>
  api.post("/careers/apply", formData).then((r) => r.data);
